var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gb_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.67,
  d: "M250 0h500v500H250z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gb_svg__a)",
  transform: "translate(-256)scale(1.024)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006",
  d: "M0 0h1000.02v500.01H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0v55.903l888.218 444.11h111.802V444.11L111.802.003H0zm1000.02 0v55.9L111.802 500.01H0v-55.9L888.218 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M416.675 0v500.01h166.67V0zM0 166.67v166.67h1000.02V166.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c00",
  d: "M0 200.004v100.002h1000.02V200.004zM450.01 0v500.01h100V0zM0 500.01l333.34-166.67h74.535L74.535 500.01zM0 0l333.34 166.67h-74.535L0 37.27zm592.145 166.67L925.485 0h74.535L666.68 166.67zm407.875 333.34L666.68 333.34h74.535l258.805 129.403z"
})))));
export default SvgGb;